module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_bottom_gray-7d1f1dd13ea4533f25d362b614ee0b1f.svg";